import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/router';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
import { shouldShowCatalog } from '@/utils';
import styles from './SearchByVinNumber.module.scss';
import Divider from '@/components/Divider';

const defaultStyles = 'text-left w-full text-lg font-medium';

const SearchByVinNumber = ({ data }: { data: any }) => {
  const router = useRouter();
  const isMercedes = router.query.origin === 'oemstar.co.uk';

  return (
    <div className={cx('bg-brand-100', styles.container)}>
      <h1
        className={cx(
          'text-white font-bold text-2xl md:text-4xl leading-[44px] text-left w-full ',
        )}
      >
        {data.title}
      </h1>
      <Divider className="my-8" />
      <p className={cx('text-white mb-12', defaultStyles)}>
        {data.description}
      </p>

      {shouldShowCatalog(router.query.origin) ? (
        <>
          <h2 className={cx('text-white', defaultStyles)}>
            Please select catalog below:
          </h2>
          <div className="flex gap-[36px] w-full mt-4">
            <a
              className="flex gap-2 justify-center items-center py-[14px] px-[28px] bg-[#947132] rounded-[6px] font-medium text-base text-[#ffffff] hover:bg-[#765a28]"
              href="/catalog"
            >
              <Image
                width={16}
                height={16}
                src="/icons/car.svg"
                alt="Car icon"
              />
              {shouldShowCatalog(router.query.origin) && !isMercedes ? (
                <p>Catalog</p>
              ) : (
                <p>Cars</p>
              )}
            </a>
            {isMercedes && (
              <a
                className="flex gap-2 justify-center items-center py-[14px] px-[28px] bg-[#947132] rounded-[6px] font-medium text-base text-[#ffffff] hover:bg-[#765a28]"
                href="/catalog"
              >
                <Image
                  width={18}
                  height={18}
                  src="/icons/truck.svg"
                  alt="Truck icon"
                />
                <p>Truck|Bus</p>
              </a>
            )}
          </div>
        </>
      ) : (
        <>
          <h2 className={cx('text-white', defaultStyles)}>
            Suggested online catalogs:
          </h2>
          <p
            className={twMerge('text-gold-50 pt-3', defaultStyles, 'text-2xl')}
          >
            <a
              href={data.linkOne.href}
              rel="noreferrer"
              target="_blank"
              data-cy="ssg-asia"
            >
              {data.linkOne.title}
            </a>
          </p>
          {data.linkTwo && (
            <p
              className={twMerge(
                'text-gold-50 pt-3',
                defaultStyles,
                'text-2xl',
              )}
            >
              <a
                href={data.linkTwo.href}
                rel="noreferrer"
                target="_blank"
                data-cy="ilcats"
              >
                {data.linkTwo.title}
              </a>
            </p>
          )}
        </>
      )}

      <h2 className={cx('text-white mt-12 mb-3', defaultStyles)}>
        Useful tips:
      </h2>
      <ul className={cx('text-white list-disc pl-6', defaultStyles)}>
        <li>
          Don’t know how to search for parts in the online car parts catalog?{' '}
          <Link href="/faq#faq-25" className="text-gold-50">
            Click here to find out more.
          </Link>
        </li>
        <li>{data.listItem2}</li>
        <li>
          How to find VIN number? Vehicle identification/chassis number (VIN) is
          at the bottom left or right side of the windshield and in the car
          registration document V5.{' '}
          <Link href="/faq#faq-11" className="text-gold-50">
            Click here to find out more.
          </Link>
        </li>
      </ul>
      <p className={cx('text-white mt-8', defaultStyles)}>{data.thankYou}</p>
      {!!data?.regards && (
        <p className={cx('text-white mt-8', defaultStyles)}>{data.regards}</p>
      )}
    </div>
  );
};

export default SearchByVinNumber;
